import { render, staticRenderFns } from "./CustomerRecycleBin.vue?vue&type=template&id=2fe98928&scoped=true"
import script from "./CustomerRecycleBin.vue?vue&type=script&lang=js"
export * from "./CustomerRecycleBin.vue?vue&type=script&lang=js"
import style0 from "./CustomerRecycleBin.vue?vue&type=style&index=0&id=2fe98928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe98928",
  null
  
)

export default component.exports